export const PRIMARY_COLOR_COMPONENT_STYLES = `
  .btn-primary, .btn-light-primary, .btn-outline-primary {
    --bs-btn-hover-color: var(--bs-primary-inverse);
    --bs-btn-hover-bg: var(--bs-primary-active);
    --bs-btn-hover-border-color: var(--bs-primary-active);
    --bs-btn-focus-shadow-rgb: var(--bs-primary-rgb);
    --bs-btn-active-color: var(--bs-primary-inverse);
    --bs-btn-active-bg: var(--bs-primary-active);
    --bs-btn-active-border-color: var(--bs-primary-active);
  }
  .btn-primary {
    --bs-btn-color: var(--bs-primary-inverse);
    --bs-btn-bg: var(--bs-primary);
    --bs-btn-border-color: var(--bs-primary);
    --bs-btn-disabled-color: var(--bs-primary-inverse);
    --bs-btn-disabled-bg: var(--bs-primary);
    --bs-btn-disabled-border-color: var(--bs-primary);
  }
  .btn-light-primary {
    --bs-btn-color: var(--app-primary-text);
    --bs-btn-bg: var(--bs-primary-light);
    --bs-btn-border-color: transparent;
    --bs-btn-disabled-color: var(--app-primary-text);
    --bs-btn-disabled-bg: var(--bs-primary-light);
    --bs-btn-disabled-border-color: transparent;
  }
  .btn-outline-primary {
    --bs-btn-color: var(--app-primary-text);
    --bs-btn-border-color: var(--bs-primary);
    --bs-btn-disabled-color: var(--app-primary-text);
    --bs-btn-disabled-border-color: var(--bs-primary);
  }
  .pagination {
    --bs-pagination-color: var(--app-primary-text);
    --bs-pagination-hover-color: var(--app-primary-text);
    --bs-pagination-focus-color: var(--app-primary-text);
    --bs-pagination-active-color: var(--bs-primary-inverse);
    --bs-pagination-active-bg: var(--bs-primary);
    --bs-pagination-active-border-color: var(--bs-primary);
  }
  .progress { --bs-progress-bar-bg: var(--bs-primary); }
  .list-group {
    --bs-list-group-active-color: var(--bs-primary-inverse);
    --bs-list-group-active-bg: var(--bs-primary);
    --bs-list-group-active-border-color: var(--bs-primary);
  }
  .dropdown-menu {
    --bs-dropdown-link-active-color: var(--bs-primary-inverse);
    --bs-dropdown-link-active-bg: var(--bs-primary);
  }
  .form-range::-webkit-slider-thumb { background-color: var(--bs-primary); }
  .form-range::-moz-range-thumb { background-color: var(--bs-primary); }
  .text-primary, .link-primary, .link-primary:is(:hover, :focus), .text-hover-primary:hover {
    color: var(--app-primary-text) !important;
  }
  .badge.badge-light-primary, .badge.badge-primary.badge-outline {
    color: var(--app-primary-text);
  }
  .bg-primary.text-white, .bg-primary .text-white {
    color: var(--bs-primary-inverse) !important;
  }
  .btn.btn-light-primary, .btn.btn-light-primary i, .btn.btn-light-primary .svg-icon,
  .btn.btn-outline-primary, .btn.btn-outline-primary i, .btn.btn-outline-primary .svg-icon,
  .btn.btn-outline.btn-outline-primary {
    color: var(--app-primary-text);
  }
  .btn.btn-outline.btn-outline-primary { --bs-primary-active: var(--app-primary-text); }
  .btn.btn-color-primary, .btn.btn-active-color-primary, .btn.btn-active-light-primary {
    --bs-primary: var(--app-primary-text);
  }
`;
